
  // Export
  module.exports =
  {

    // Search scripts
    search:
    {

      // Method-wide scripts
      _init: function ()
      {
        APPLICATION._APPLICATION.load($('#boms'), APPLICATION._PATH_PREFIX + 'bom/boms', 'Bom', 'boms')        
      }

    },
    searchrange:
    {

      // Method-wide scripts
      _init: function ()
      {
        APPLICATION._APPLICATION.load($('#boms'), APPLICATION._PATH_PREFIX + 'bom/boms', 'Bom', 'boms')        
      }

    },

    // Call off dashboard scripts
    callOffDashboard:
    {

      // Method-wide scripts
      _init: function ()
      {
        APPLICATION._APPLICATION.load($('#boms'), APPLICATION._PATH_PREFIX + 'bom/boms?show_full=1', 'Bom', 'boms') 
      }

    },

    // BOMs scripts
    boms:
    {

      // Method-wide scripts
      _init: function ()
      {

        APPLICATION._APPLICATION.processLinks('#boms', 'Bom', 'boms')

        // Get the development
        var development = $('#development_id')

        // On changing the company
        $('#company_id').not('.js-ignore').change(function ()
        {

          // Get the company ID
          var company_id = $(this).val()

          // If no brand or company
          if ('' === company_id)
          {
            development.next('.dropdown-menu').html('')
          }

          // Otherwise
          else
          {
            APPLICATION._APPLICATION.loadDropdown(development, APPLICATION._PATH_PREFIX + 'development/dropdown/' + company_id + '?development_id=' + development.val(), 'Development', 'dropdown')
          }

        }
        ).addClass('js-ignore').trigger('change')

      }

    },

    // Development scripts
    development:
    {

      // Method-wide scripts
      _init: function ()
      {

        // On changing the company
        $('#company_id').not('.js-ignore').change(function ()
        {

          // Get the company ID
          var company_id = $(this).val()

          // Get the phase
          var phase = $('#phase_id')

          // Load the phases
          APPLICATION._APPLICATION.loadDropdown(phase, APPLICATION._PATH_PREFIX + 'company/phases/' + company_id + '?phase_id=' + phase.val(), 'Company', 'phases')

        }
        ).addClass('js-ignore').trigger('change')

        // On changing the phase
        $('#phase_id').not('.js-ignore').change(function ()
        {

          // If a change
          if (String($(this).val()) !== String($(this).data(APPLICATION._DATA_PREFIX + 'default')))
          {

            // Hide edit existing button
            $('#edit-existing').hide()
  
            // Show continue button
            $('#continue').show()

          }

        }
        ).addClass('js-ignore')

      }

    },

    // Edit scripts
    edit:
    {

      // Method-wide scripts
      _init: function ()
      {

        // On changing the quantity required
        $('.js-calc').not('.js-ignore').change(function ()
        {

          // Get the value
          var value = parseInt($(this).val() || '0', 10)

          // Determine the product ID
          switch (parseInt($(this).data(APPLICATION._DATA_PREFIX + 'product_id'), 10))
          {

            // Code 20731
            case 1:

              // Iterate over the calcs
              $('.js-calc').each(function ()
              {

                // The product ID
                var product_id = parseInt($(this).data(APPLICATION._DATA_PREFIX + 'product_id'), 10)

                // If to match
                if (-1 !== [9, 10, 11].indexOf(product_id))
                {
                  $(this).val(Math.ceil(value * 0.1 / 3))
                }

              }
              )

              // Break
              break

            // Code 1552
            case 2:

              // Iterate over the calcs
              $('.js-calc').each(function ()
              {

                // The product ID
                var product_id = parseInt($(this).data(APPLICATION._DATA_PREFIX + 'product_id'), 10)

                // If to match
                if (-1 !== [3, 13, 19, 25, 26].indexOf(product_id))
                {
                  $(this).val(value)
                }

              }
              )

              // Break
              break

            // Code 73795, 9053
            case 21:
            case 44:

              // Iterate over the calcs
              $('.js-calc').each(function ()
              {

                // The product ID
                var product_id = parseInt($(this).data(APPLICATION._DATA_PREFIX + 'product_id'), 10)

                // If to match
                if (-1 !== [20].indexOf(product_id))
                {

                  // The value
                  var value = parseInt($('.js-calc[data-' + APPLICATION._DATA_PREFIX + 'product_id="21"]').val() || '0', 10)
                            + parseInt($('.js-calc[data-' + APPLICATION._DATA_PREFIX + 'product_id="44"]').val() || '0', 10)

                  $(this).val(Math.ceil(value * 4))

                }

                // If to match
                if (-1 !== [45].indexOf(product_id))
                {

                  // The value
                  var value = parseInt($('.js-calc[data-' + APPLICATION._DATA_PREFIX + 'product_id="21"]').val() || '0', 10)
                            + parseInt($('.js-calc[data-' + APPLICATION._DATA_PREFIX + 'product_id="44"]').val() || '0', 10)

                  $(this).val(Math.ceil(value))

                }

              }
              )

              // Break
              break

            // Code 73796
            case 23:

              // Iterate over the calcs
              $('.js-calc').each(function ()
              {

                // The product ID
                var product_id = parseInt($(this).data(APPLICATION._DATA_PREFIX + 'product_id'), 10)

                // If to match
                if (-1 !== [22].indexOf(product_id))
                {
                  $(this).val(value * 5)
                }

              }
              )

              // Break
              break

            // Code 63347
            case 27:

              // Iterate over the calcs
              $('.js-calc').each(function ()
              {

                // The product ID
                var product_id = parseInt($(this).data(APPLICATION._DATA_PREFIX + 'product_id'), 10)

                // If to match
                if (-1 !== [28].indexOf(product_id))
                {
                  $(this).val(value)
                }

              }
              )

              // Break
              break

          }

        }
        ).addClass('js-ignore')

        return

        // On changing the quantity required
        $('.js-quantity_required').not('.js-ignore').change(function ()
        {

          // Get the product
          var product = $(this).closest('.js-product')

          // Set quantity
          APPLICATION.Bom.edit.setQuantity(product)

          // Set outstanding
          APPLICATION.Bom.edit.setOutstanding(product)

          // Set cost difference
          APPLICATION.Bom.edit.setCostDifference(product)

          // Set total designed
          APPLICATION.Bom.edit.setTotalDesigned()

          // Set total difference
          APPLICATION.Bom.edit.setTotalDifference()

        }
        ).addClass('js-ignore')

        // On changing the amount delivered
        $('.js-delivered_packs, .js-delivered_items').not('.js-ignore').change(function ()
        {

          // Get the product
          var product = $(this).closest('.js-product')

          // Set delivered
          APPLICATION.Bom.edit.setDelivered(product)

          // Set outstanding
          APPLICATION.Bom.edit.setOutstanding(product)

          // Set cost difference
          APPLICATION.Bom.edit.setCostDifference(product)
  
          // Set total delivered
          APPLICATION.Bom.edit.setTotalDelivered()

          // Set total difference
          APPLICATION.Bom.edit.setTotalDifference()

        }
        ).addClass('js-ignore')

        // Iterate over each product
        $('.js-product').not('.js-ignore').each(function ()
        {

          // Get the product
          var product = $(this)

          // Set quantity
          APPLICATION.Bom.edit.setQuantity(product)

          // Set delivered
          APPLICATION.Bom.edit.setDelivered(product)

          // Set outstanding
          APPLICATION.Bom.edit.setOutstanding(product)

          // Set cost difference
          APPLICATION.Bom.edit.setCostDifference(product)

        }
        ).addClass('js-ignore')

        // Set total designed
        APPLICATION.Bom.edit.setTotalDesigned()

        // Set total delivered
        APPLICATION.Bom.edit.setTotalDelivered()

        // Set total difference
        APPLICATION.Bom.edit.setTotalDifference()

      },

      // Set the quantity
      setQuantity: function (product)
      {

        // Get the quantity
        var quantity = parseInt($('.js-quantity', product).val(), 10)

        // Get the quantity required
        var quantity_required = parseInt($('.js-quantity_required', product).val(), 10) || 0

        // Set the total packs
        $('.js-total_packs', product).text(parseFloat(quantity_required / quantity).toFixed(2))

        // Get the packs
        var packs = Math.floor(quantity_required / quantity)

        // Get the items
        var items = quantity_required - (packs * quantity)

        // Set the total packs items
        $('.js-total_packs_items', product).text(packs + ' + ' + items)

        // Get the cost
        var cost = parseFloat($('.js-cost', product).val())

        // Set the cost designed
        $('.js-cost_designed', product).text(APPLICATION._APPLICATION.thousandsSeparator(parseFloat(quantity_required * cost).toFixed(2)))

      },

      // Set the delivered
      setDelivered: function (product)
      {

        // Get the quantity
        var quantity = parseInt($('.js-quantity', product).val(), 10)

        // Get the packs
        var packs = parseInt($('.js-delivered_packs', product).val(), 10) || 0

        // Get the items
        var items = parseInt($('.js-delivered_items', product).val(), 10) || 0

        // Get the total
        var total = (packs * quantity) + items

        // Set the delivered total
        $('.js-delivered_total', product).text(total)

        // Get the cost
        var cost = parseFloat($('.js-cost', product).val())

        // Set the cost delivered
        $('.js-cost_delivered', product).text(APPLICATION._APPLICATION.thousandsSeparator(parseFloat(total * cost).toFixed(2)))

      },

      // Set the outstanding
      setOutstanding: function (product)
      {

        // Get the quantity
        var quantity = parseInt($('.js-quantity', product).val(), 10)

        // Get the quantity required
        var quantity_required = parseInt($('.js-quantity_required', product).val(), 10) || 0

        // Get the delivered total
        var delivered_total = parseInt($('.js-delivered_total', product).text(), 10) || 0

        // Get the packs
        var packs = Math.floor((quantity_required - delivered_total) / quantity)

        // Get the items
        var items = quantity_required - delivered_total - (packs * quantity)

        // Get the totsl
        var total = packs * quantity + items

        // Set the outstanding packs
        $('.js-outstanding_packs', product).text(packs)

        // Set the outstanding items
        $('.js-outstanding_items', product).text(items)

        // Set the outstanding total
        $('.js-outstanding_total', product).text(total)

      },

      // Set the cost difference
      setCostDifference: function (product)
      {

        // Get the cost designed
        var designed = parseFloat($('.js-cost_designed', product).text().replace(/,/g, '')) || 0

        // Get the cost delivered
        var delivered = parseFloat($('.js-cost_delivered', product).text().replace(/,/g, '')) || 0

        // Set the cost difference
        $('.js-cost_difference', product).text(APPLICATION._APPLICATION.thousandsSeparator(parseFloat(delivered - designed).toFixed(2)))

      },

      // Set the total designed
      setTotalDesigned: function ()
      {

        // The total
        var total = 0.00

        // Iterate over each product
        $('.js-product').each(function ()
        {

          // Get the product
          var product = $(this)

          // Get the quantity required
          var quantity_required = parseInt($('.js-quantity_required', product).val(), 10) || 0
  
          // Get the cost
          var cost = parseFloat($('.js-cost', product).val())
  
          // Add the total
          total += quantity_required * cost

        }
        )
  
        // Set the cost designed
        $('#cost-designed').text(APPLICATION._APPLICATION.thousandsSeparator(parseFloat(total).toFixed(2)))

      },

      // Set the total delivered
      setTotalDelivered: function ()
      {

        // The total
        var total = 0.00

        // Iterate over each product
        $('.js-product').each(function ()
        {

          // Get the product
          var product = $(this)

          // Get the total
          var delivered_total =  parseFloat($('.js-delivered_total', product).text()) || 0
  
          // Get the cost
          var cost = parseFloat($('.js-cost', product).val())
  
          // Add the total
          total += delivered_total * cost

        }
        )
  
        // Set the cost designed
        $('#cost-delivered').text(APPLICATION._APPLICATION.thousandsSeparator(parseFloat(total).toFixed(2)))

      },

      // Set the total difference
      setTotalDifference: function ()
      {

        // Get the cost designed
        var designed = parseFloat($('#cost-designed').text().replace(/,/g, '')) || 0

        // Get the cost delivered
        var delivered = parseFloat($('#cost-delivered').text().replace(/,/g, '')) || 0

        // Set the cost difference
        $('#cost-difference').text(APPLICATION._APPLICATION.thousandsSeparator(parseFloat(delivered - designed).toFixed(2)))

      }

    }

  }